import React, { useState, useEffect } from "react";
// import "../App.css";
import { Helmet } from "react-helmet-async";
import ParallaxSection from '../components/ParallaxSection'
import VCNRMediaContact from "../components/Contact/VCNRMediaContact";
import VCNRContactHospitalBanner from "../components/Contact/VCNRContactHospitalBanner";
import ContactConversationSection from "../components/Contact/ContactConversationSection";
import VCNRLocationMap from "../components/Contact/VCNRLocationMap"
import VCNRContactSection from "../components/Contact/VCNRContactSection"
import EnquiryFormSection from "../components/Contact/EnquiryFormSection"
import LogoCarousel from "../components/LogoCarousel";
import contactbanner from "../Assets/contact/contactbanner.png";
import HeartBanner from "../components/Health/HeartBanner";
import seoMeta from "./seoMeta";
import { useLocation, useNavigate } from "react-router-dom";

const Contact = () => {
  const navigate=useNavigate();
    const location = useLocation();
  useEffect(() => {
    const hash = location.hash?.replace('#', '');
    if (hash) {
      setTimeout(() => {
        const el = document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }, [location]);
  const meta = seoMeta["/Contact"];
const logos = [
  { src: require('../Assets/LOGO/client1.png'), alt: 'Nestle' },
  { src: require('../Assets/LOGO/client2.png'), alt: 'Godrej' },
  { src: require('../Assets/LOGO/client3.png'), alt: 'Bajaj' },
  { src: require('../Assets/LOGO/client4.png'), alt: 'Reliance' },
  { src: require('../Assets/LOGO/client5.png'), alt: 'Safexpress' },
  { src: require('../Assets/LOGO/client6.png'), alt: 'JWL' },
  { src: require('../Assets/LOGO/client7.png'), alt: 'GIRIAS' },
  { src: require('../Assets/LOGO/client8.png'), alt: 'Nestle' },
    { src: require('../Assets/LOGO/client9.png'), alt: 'Denso' },
      { src: require('../Assets/LOGO/client10.png'), alt: 'Britania' },
        { src: require('../Assets/LOGO/client11.png'), alt: 'fsc' },
          { src: require('../Assets/LOGO/client12.png'), alt: 'ITC' },
            { src: require('../Assets/LOGO/client13.png'), alt: 'scope' },
            { src: require('../Assets/LOGO/client14.png'), alt: 'Flipkart' },
          ];

  return (
<>
    <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="keywords" content={meta.keywords} />
      </Helmet>
    <HeartBanner
      heading={"Inquiry to Impact<br />Let’s Begin."}
      subtext=" Every meaningful journey starts with a question. Whether you're exploring collaborations, seeking care, or aiming to create lasting social impact—your inquiry is the first step toward transformative action with VCNR."
      buttonText="Our verticals"
  onButtonClick={() => navigate("/Contact")}
      peopleImageSrc={contactbanner}
      pulseLineSrc=""
      heartImageSrc=""
/>
          <div id="ContactSection"><VCNRContactSection /></div>
          <div className="section-wrapper sec-bg" id="VCNRGroup"><ParallaxSection><VCNRContactHospitalBanner />
          <div id="EnquiryForm"><EnquiryFormSection /></div>
          </ParallaxSection></div>
          {/* <div className="section-wrapper"><ParallaxSection><EnquiryFormSection /></ParallaxSection></div> */}
          <div className="section-wrapper" id="VCNRMedia"><ParallaxSection><VCNRMediaContact /></ParallaxSection></div>
          <VCNRLocationMap />
          <div className="section-wrapper" id="VCNRClientsLogo"><ParallaxSection><LogoCarousel logos={[...logos, ...logos]} /></ParallaxSection></div>
          <div className="section-wrapper" id="VCNRSocialMedia"><ParallaxSection><ContactConversationSection /></ParallaxSection></div>
         
         
 
    </>
  );
};

export default Contact;
